import { createAction, props } from '@ngrx/store';

import { AlertDtoStoreModel } from '@domain/alerting/alerting.models';
import {
  DashboardOverviewStoreModel,
  DashboardStatsStoreModel,
  EnergyCostStoreModel,
  VehicleStateOfChargeSummaryResponseStoreModel,
} from '@domain/multi-site-dashboard/multi-site-dashboard.models';

import { MovableCardsContainerViewModel } from '@shared/components/movable-cards-container';
import { AlertingTableSortPropertyStoreModelEnum } from '@shared/enums/alerting-table-sort-property.enum';
import { SortDirectionStoreModelEnum } from '@shared/enums/sort-direction.enum';

import { EnergyCostRange } from '../enums/energy-cost-range.enum';
import { MultiSiteDashboardCard } from '../enums/multi-site-dashboard-card.enum';
import { VehicleSocSummaryRange } from '../enums/vehicle-soc-summary-range.enum';

export const selectTenant = createAction('[Multi Site Dashboard] select tenant', props<{ tenantId: string }>());
export const reconcileSelectedTenant = createAction('[Multi Site Dashboard] reconcile selected tenant');
export const reconcileSelectedTenantAfterActiveUserChange = createAction(
  '[Multi Site Dashboard] reconcile selected tenant after active user change'
);
export const setReconciledSelectedTenant = createAction(
  '[Multi Site Dashboard] set reconciled selected tenant',
  props<{ tenantId: string | undefined; reloadData?: boolean }>()
);

export const loadOverview = createAction('[Multi Site Dashboard] load overview');
export const loadOverviewSuccess = createAction(
  '[Multi Site Dashboard] load overview success',
  props<{ overview: DashboardOverviewStoreModel }>()
);
export const loadOverviewFailure = createAction('[Multi Site Dashboard] load overview failure', props<{ error: string }>());
export const overviewSocketMessageArrive = createAction(
  '[Multi Site Dashboard] overview socket message arrive',
  props<{ overview: DashboardOverviewStoreModel }>()
);
export const clearOverview = createAction('[Multi Site Dashboard] clear overview');

export const loadStats = createAction('[Multi Site Dashboard] load stats');
export const loadStatsSuccess = createAction('[Multi Site Dashboard] load stats success', props<{ stats: DashboardStatsStoreModel }>());
export const loadStatsFailure = createAction('[Multi Site Dashboard] load stats failure', props<{ error: string }>());
export const clearStats = createAction('[Multi Site Dashboard] clear stats');

export const loadSiteAlerts = createAction('[Multi Site Dashboard] load site alerts', props<{ polling?: boolean }>());
export const loadSiteAlertsSuccess = createAction(
  '[Multi Site Dashboard] load site alerts success',
  props<{ alerts: AlertDtoStoreModel[]; polling?: boolean }>()
);
export const loadSiteAlertsFailure = createAction('[Multi Site Dashboard] load site alerts failure', props<{ error: string }>());
export const clearSiteAlerts = createAction('[Multi Site Dashboard] clear site alerts');

export const setSiteAlertsTableSortProperties = createAction(
  '[Multi Site Dashboard] set site alerts table sort properties',
  props<{ sortProperty: AlertingTableSortPropertyStoreModelEnum; sortDirection: SortDirectionStoreModelEnum }>()
);

export const loadEnergyCost = createAction('[Multi Site Dashboard] load energy cost', props<{ range: EnergyCostRange }>());
export const loadEnergyCostSuccess = createAction(
  '[Multi Site Dashboard] load energy cost success',
  props<{ energyCost: EnergyCostStoreModel }>()
);
export const loadEnergyCostFailure = createAction('[Multi Site Dashboard] load energy cost failure', props<{ error: string }>());
export const setEnergyCostRange = createAction('[Multi Site Dashboard] set energy cost range', props<{ range: EnergyCostRange }>());
export const clearEnergyCost = createAction('[Multi Site Dashboard] clear energy cost');

export const loadVehicleStateOfChargeSummary = createAction(
  '[Multi Site Dashboard] load vehicle state of charge summary',
  props<{ range: VehicleSocSummaryRange }>()
);
export const loadVehicleStateOfChargeSummarySuccess = createAction(
  '[Multi Site Dashboard] load vehicle state of charge summary success',
  props<{ summary: VehicleStateOfChargeSummaryResponseStoreModel }>()
);
export const loadVehicleStateOfChargeSummaryFailure = createAction(
  '[Multi Site Dashboard] load vehicle state of charge summary failure',
  props<{ error: string }>()
);
export const setVehicleSocSummaryRange = createAction(
  '[Multi Site Dashboard] set vehicle state of charge summary range',
  props<{ range: VehicleSocSummaryRange }>()
);
export const clearVehicleStateOfChargeSummary = createAction('[Multi Site Dashboard] clear vehicle state of charge summary');

export const clearMultiSiteDashboardData = createAction('[Multi Site Dashboard] clear data');

export const setCardsLayout = createAction(
  '[Multi Site Dashboard] set cards layout',
  props<{ layout: MovableCardsContainerViewModel<MultiSiteDashboardCard> }>()
);
